<template>
	<dialog-slot
			:title="dialogTitle"
			@updateClose="onClose"
			@updateSave="onSave"
			width="580px"
			apply-text="Save"
			:preloader="isPreloader"
	>
		<div class="bonusChargePopup">
			<div class="groupField">
				<field
						:class-error="getError('type')"
						margin="0"
						width="100%"
						label="Type"
						placeholder="Select type"
						@updateSelect="onAutocomplete($event, 'type')"
						:autocompleteValue="type"
						:items="typeList"
						:isClearable="false"
						is-select
						is-required
				></field>
				<field
						:class-error="getError('department')"
						margin="0"
						width="100%"
						label="Department"
						placeholder="Select department"
						@updateSelect="onAutocomplete($event, 'department')"
						:autocompleteValue="department"
						:items="departmentList"
						:isClearable="false"
						is-select
						is-required
				></field>
			</div>
			<div class="groupField">
				<field
						:class-error="getError('employee')"
						margin="0"
						width="100%"
						label="Name"
						placeholder="Select name"
						@updateSelect="onAutocomplete($event, 'employee')"
						:autocompleteValue="employee"
						:items="employeesList"
						:isClearable="false"
						is-select
						is-required
						:is-disabled="!department"
				></field>
				<field
						:class-error="getError('sum')"
						margin="0"
						width="100%"
						label="Sum"
						type="number"
						placeholder="Enter sum"
						:setInputValue="sum"
						@updateInput="onInput($event, 'sum')"
						is-required
				></field>
			</div>
			<div class="groupField">
				<field
						:class-error="getError('date')"
						margin="0"
						width="100%"
						type="text"
						label="Date from"
						placeholder="Enter date"
						:dateValue="date"
						@updateDate="onDate"
						is-date
						is-no-title
						is-required
				></field>
				<field
						margin="0"
						width="100%"
						label="File"
						placeholder="add file"
						:setInputValue="file.name"
						@updateFile="onFile($event)"
						is-file
						is-readonly
				></field>
			</div>

			<div class="groupField">
				<field
						margin="0"
						width="100%"
						padding="10px 10px 0"
						label="Description"
						placeholder="Enter description"
						:setInputValue="description"
						@updateInput="onInput($event, 'description')"
						is-textarea
				></field>
			</div>
		</div>

	</dialog-slot>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// helper
import { errorMessage } from "@/helper";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "BonusChargeCreate",
	mixins: [ validationMixin ],
	components: { DialogSlot },
	props: {
		itemId: Number
	},
	validations: {
		type: { required },
		department: { required },
		employee: { required },
		sum: { required },
		date: { required },
	},
	computed: {
		...mapGetters([ 'bonusCharge' ]),
		dialogTitle() {
			return this.itemId ? 'Edit bonus charge' : 'Create bonus charge';
		}
	},
	data: () => ({
		isPreloader: false,
		type: null,
		typeList: null,
		department: null,
		departmentList: [],
		employee: null,
		employeesList: [],
		sum: null,
		description: "",
		date: null,
		file: {
			name: "",
			value: ""
		},
		id: null,
	}),
	methods: {
		...mapActions([ "onBonusChargeCreate", "onBonusChargeSave", "setAlert", 'onBonusChargeEdit' ]),
		onClose() {
			this.$emit("updateClose");
		},
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { type, department, employee, sum, date, description, file, id } = this.$data;
				const values = { type, department, employee, sum, date, description, file, id };
				if (this.itemId) values.id = this.itemId;
				const { status, error } = await this.onBonusChargeSave(values);
				if (status) {
					const message = this.itemId ? "Editing was successful" : "Saving success";
					this.setAlert({ type: "success", message });
					this.onClose();
				} else {
					errorMessage(error);
				}
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		async onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
			if (key === "department") {
				this.isPreloader = true;
				this.employee = null;
				const { employees, department } = await this.onBonusChargeCreate(value?.id);
				this.employeesList = employees;
				this.departmentList = department;
				this.isPreloader = false;
			}
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onDate(value) {
			this.date = value;
		},
		onFile(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
			};
		},
	},
	async mounted() {
		this.isPreloader = true;
		if (this.itemId) {
			await this.onBonusChargeEdit(this.itemId);
		} else {
			await this.onBonusChargeCreate(null);
			
		}
  
		if (this.bonusCharge) {
			const { employees, department, type, row } = this.bonusCharge;
			this.employeesList = employees;
			this.departmentList = department;
			this.typeList = type;
   
			if (row) {
				const { date, employee_id, total, type: typeId, department_id, description, file_name: name, file_url: value, id } = row;
				this.date = date;
				this.employee = employee_id;
				this.sum = total;
				this.type = typeId;
				this.department = department_id;
				this.description = description;
				this.file = { name, value };
				this.id = id;
			}
		}
  
		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
.bonusChargePopup {
	display: flex;
	flex-direction: column;
	gap: 10px;
	.groupField {
		display: flex;
		align-items: flex-start;
		gap: 10px;
	}
}
</style>
